/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-11-30 16:04:39
 */
import { Post, Get, Patch, Put, Delete, Download, ax,GetBlod } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace yun {
    /**
     * 获取数组字典列表
     */
    export var GetDicList = (data: any): Promise<any> => {
        return Get(`/msls/DataDictionary/GetDicDetailList?${qs.stringify(data)}`, {});
    };
    /**
     * 获取车辆列表
     */
    export var GetCarList = (data: any): Promise<any> => {
        return Get(`/msls/Car/GetCarList?${qs.stringify(data)}`, {});
    };
    /**
     *  新增车辆
     */
    export var CarAdd = (data: any): Promise<any> => {
        return Post(`/msls/Car/Add`, data);
    };
    /**
     * 获取车辆详情
     */
    export var GetDetai1 = (data: any): Promise<any> => {
        return Get(`/msls/Car/GetDetail/` + data, {});
    };
    /**
     * 编辑车辆
     */
    export var CarUpdate = (data: any): Promise<any> => {
        return Put(`/msls/Car/Update/` + data.id, data);
    };
    /**
     * 删除车辆
     */
    export var CarDelete = (data: any): Promise<any> => {
        return Delete(`/msls/Car/Delete/` + data, {});
    };
    /**
     * 获取关联司机列表
     */
    export var GetBindCarList = (data: any): Promise<any> => {
        return Get(`/msls/Car/GetBindDriverList?${qs.stringify(data)}`, {});
    };
    /**
     *  导出车辆列表
     */
    export var CarExport = (data: any): Promise<any> => {
        return Download(`/msls/Car/Export?${qs.stringify(data)}`, {});
    };
    /**
     *  导入车辆
     */
    export var CarImportCars = (data): Promise<any> => {
        return Post(`/msls/Car/ImportCars`, data);
    };
    /**
     *  获取司机列表
     */
    export var GetDriverList = (data: any): Promise<any> => {
        return Get(`/msls/Driver/GetDriverList?${qs.stringify(data)}`, {});
    };
    /**
     *  新增司机
     */
    export var DriverAdd = (data: any): Promise<any> => {
        return Post(`/msls/Driver/Add`, data);
    };
    /**
     * 获取司机详情
     */
    export var DriverDetai1 = (data: any): Promise<any> => {
        return Get('/msls/Driver/GetDetail/' + data, {});
    };
    /**
     * 编辑司机
     */
    export var DriverUpdate = (data: any): Promise<any> => {
        return Put(`/msls/Driver/Update/` + data.id, data);
    };
    /**
     * 删除司机
     */
    export var DriverDelete = (data: any): Promise<any> => {
        return Delete(`/msls/Driver/Delete/` + data, {});
    };
    /**
     *  绑定
     */
    export var DriverBind = (data: any): Promise<any> => {
        return Post(`/msls/Driver/Bind`, data);
    };
    /**
     * 获取关联车辆列表
     */
    export var DriverGetBindCarList = (data: any): Promise<any> => {
        return Get(`/msls/Driver/GetBindCarList?${qs.stringify(data)}`, {});
    };
    /**
     *  解绑
     */
    export var DriverUnbind = (data: any): Promise<any> => {
        // console.log('data',data)
        return Delete(`/msls/Driver/Unbind?${qs.stringify(data)}`, '');
    };
    /**
     *  实名认证
     */
    export var IDAuthentication = (data: any): Promise<any> => {
        return Put(`/msls/Driver/IDAuthentication/` + data, {});
    };
    /**
     *  导出司机列表
     */
    export var DriverExport = (data: any): Promise<any> => {
        return Download(`/msls/Driver/Export?${qs.stringify(data)}`, {});
    };
    /**
     *  导入司机
     */
    export var DriverImportCars = (data): Promise<any> => {
        return Post(`/msls/Driver/ImportDrivers?${qs.stringify(data)}`, {});
    };
    /**
     *  获取承运商
     */
    export var GetCarrierList = (data): Promise<any> => {
        return Get(`/msls/Carrier/GetCarrierList`, data);
    };
    /**
     *  导入司机
     */
    export var ContractGetList = (data): Promise<any> => {
        return Get(`/msls/Contract/GetList?${qs.stringify(data)}`, {});
    };
    /**
     *  获取承运商
     */
    export var ContractAdd = (data): Promise<any> => {
        return Post(`/msls/Contract/Add`, data);
    };
    /**
     *  合同删除
     */
    export var ContractDelete = (data): Promise<any> => {
        return Put(`/msls/Contract/Delete/` + data, '');
    };
    /**
     *  货物列表
     */
    export var getGoodsPageList = (data): Promise<any> => {
        return Get(`/msls/Goods/getGoodsPageList?${qs.stringify(data)}`, '');
    };
    /**
     *  货物列表
     */
    export var addOrder = (data): Promise<any> => {
        return Post(`/msls/OrderApi/addOrder`, data);
    };
    /**
     *  订单列表
     */
    export var getOrderList = (data): Promise<any> => {
        return Get(`/msls/OrderApi/getOrderList?${qs.stringify(data)}`, '');
    };
    /**
     *  审核列表
     */
    export var getNetworkFreightList = (data): Promise<any> => {
        return Get(`/msls/OrderApi/getNetworkFreightList?${qs.stringify(data)}`, '');
    };
    /**
     *  报价列表
     */
    export var getQuotationList = (data): Promise<any> => {
        return Get(`/msls/OrderApi/getQuotationList?${qs.stringify(data)}`, '');
    };
    /**
     *  订单列表
     */
    export var OrdergetDetaill = (data): Promise<any> => {
        return Get(`/msls/OrderApi/getDetail/` + data, '');
    };
    export var HistoryContactgetPageList = (obj): Promise<any> => {
        return Get(`/msls/HistoryContact/getPageList?${qs.stringify(obj)}`, {});
    };
    export var AddressDistinguish = (obj): Promise<any> => {
        return Get(`/msls/AddressBook/AddressDistinguish?${qs.stringify(obj)}`, {});
    };
    export var IupdateOrderStatus = (obj): Promise<any> => {
        return Put(`/msls/OrderApi/updateOrderState`, obj);
    };
    export var deleteOrder = (data): Promise<any> => {
        return Get(`/msls/OrderApi/delOrder/` + data, '');
    };
    export var saveOrder = (data): Promise<any> => {
        return Put(`/msls/OrderApi/saveOrder/` + data.id, data);
    };
    export var orderIssueSupplier = (data): Promise<any> => {
        return Put(`/msls/OrderApi/issuedOrder/`, data);
    };
    export var updateOrderAuditStatus = (data): Promise<any> => {
        return Put(`/msls/OrderApi/updateOrderAuditStatus/`, data);
    };
    export var updateOrderFreight = (data): Promise<any> => {
        return Put(`/msls/OrderApi/updateOrderFreight/`, data);
    };
    // 订单导入
    export var orderAddExce1Data = (data): Promise<any> => {
        return Post(`/msls/OrderApi/orderAddExcelData`, data);
    };

    // 订单导入
    export var uploadexcel = (data): Promise<any> => {
        return Post(`/msls/OrderApi/uploadexcel`, data);
    };
    // 订单导入
    export var exportOrder = (data): Promise<any> => {
        return Download(`/msls/OrderApi/exportOrder?${qs.stringify(data)}`, '');
    };
    // 订单导入
    export var GetOrderTemplate = (data): Promise<any> => {
        return Download(`/msls/OrderApi/GetOrderTemplate?${qs.stringify(data)}`, '');
    };
    /**
     *  订单列表
     */
    export var pageSimpleList = (data): Promise<any> => {
        return Get(`/msls/CarrierOrder?${qs.stringify(data)}`, '');
    };
    /**
     *  订单列表
     */
    export var GetPrice = (data): Promise<any> => {
        return Get(`/msls/PriceList/GetPrice?${qs.stringify(data)}`, '');
    };
    /**
     *  订单列表
     */
    export var getSinglePriceList = (data): Promise<any> => {
        return Get(`/msls/PriceList/getSinglePriceList?${qs.stringify(data)}`, '');
    };
    /**
   * 获取异常详情
   */
    export var AnomalyGetDetail = (data: any): Promise<any> => {
        return Get(`/msls/Anomaly/GetDetail/` + data, {});
    };
    /**
     *  获取发货方下属车队
     */
    export var GetCarrierByShipper = (data: any): Promise<any> => {
        return Get(`/msls/CustomerBase/GetCarrierByCustomerBase/` + data.customerBaseId + `?${qs.stringify(data)}`, {});
    };
    // 货物导出
    export var uploadGoodsExcel = (data): Promise<any> => {
        return Post(`/msls/OrderApi`, data);
    };
    // 货物模板
    export var GetOrderGoodsTemplate = (data): Promise<any> => {
        return Download(`/msls/OrderApi${qs.stringify(data)}`, '');
    };
    /**
     *  订单列表
     */
    export var CarrierOrder = (data): Promise<any> => {
        return Post(`/msls/CarrierOrder/add`, data);
    };
    /**
     *  一件拆单
     */
    export var splitadd = (data): Promise<any> => {
        return Post(`/msls/CarrierOrder/splitadd`, data);
    };

    // 获取运费单价
    export var GetFreight = (data): Promise<any> => {
        return Get(`/msls/Inquiry/GetFreight?${qs.stringify(data)}`, '');
    };
    // 获取运费单价(并单)
    export var GetWinItems = (data): Promise<any> => {
        return Get(`/msls/Inquiry/GetWinItems?${qs.stringify(data)}`, '');
    };
    /**
     * 根据地址类型获取所有地址簿数据下拉
     */
    export var GetAddressBookList = (query: any): Promise<any> => {
        return Get(`/msls/AddressBook/GetList?${qs.stringify(query)}`, {});
    };
    // 获取发货方信息
    export var ShipperGetList = (data): Promise<any> => {
        return Get(`/msls/CustomerBase/GetDropDownList?${qs.stringify(data)}`, '');
    };
    // 获取发货方信息
    export var GetDropDownList = (data): Promise<any> => {
        return Get(`/msls/Shipper/GetDropDownList?${qs.stringify(data)}`, '');
    };

    // 获取收货方信息
    export var GetDeliveryLis = (data): Promise<any> => {
        return Get(`/msls/AddressBook/GetDeliveryList?${qs.stringify(data)}`, '');
    };
    // 获取线路（车长、车型）运价
    export var GetBasePrice = (data): Promise<any> => {
        return Get(`/msls/OrderApi/GetBasePrice?${qs.stringify(data)}`, '');
    };
    // 获取用户收货地权限
    export var getArrivalAdrDataPermissionList = (data): Promise<any> => {
        return Get(`/msls/UserApi/getArrivalAdrDataPermissionList?${qs.stringify(data)}`, '');
    };
    // 获取用户权限
    export var getSenderDataPermissionList = (data): Promise<any> => {
        return Get(`/msls/UserApi/getCustomerBaseDataPermissionList?${qs.stringify(data)}`, '');
    };

    // 获取订单打印
    export var getOrderPrintList = (data): Promise<any> => {
        return GetBlod(`/msls/OrderApi/getOrderPrintList?${qs.stringify(data)}`, '');
    };
    // 订单打印标识
    export var Print = (data): Promise<any> => {
        return Get(`/msls/OrderApi/Print?${qs.stringify(data)}`, '');
    };
    // 修改发货方权限
    export var editDataPermissions = (data): Promise<any> => {
        return Put(`/msls/UserApi/editCustomerBaseDataPermission?`, data);
    };
    // 取回计划
    export var retrieveOrder = (data): Promise<any> => {
        return Put(`/msls/OrderApi/retrieveOrder?`, data);
    };
    // 修改报价计划
    export var updateFromAuditBack = (data): Promise<any> => {
        return Put(`/msls/OrderApi/updateFromAuditBack?`, data);
    };
    // 修改发货方权限
    export var editArrivalAdrDataPermission = (data): Promise<any> => {
        return Put(`/msls/UserApi/editArrivalAdrDataPermission?`, data);
    };
    /**
*  启用 禁用司机
*/
    export var Enable = (data: any): Promise<any> => {
        return Put(`/msls/Driver/Enable`, data);
    };
        /**
*  启用 禁用车辆
*/
export var CarEnable = (data: any): Promise<any> => {
    return Put(`/msls/Car/Enable`, data);
};
    /**
     * 补传司机信息
     */
     export var PushDriverToTms = (id: any): Promise<any> => {
        return Get(`/msls/Driver/PushDriverToTms/${id}`, {})
    };
    /**
  * 补传车辆信息GET
  */
    export var PushCarToTms = (id: any): Promise<any> => {
        return Get(`/msls/Car/PushCarToTms/${id}`, {})
    };
}
